<template lang="html">
    <div
        class="view-help">
        <PageTitle
            text="Comment ça marche ?">
        </PageTitle>
        <div
            class="carousel-wrapper">
            <el-carousel
                arrow="always"
                class="help-carousel shadow"
                style="margin: 20px 0;">
                <el-carousel-item
                    v-for="(step, i) in steps"
                    :key="i">
                    <div
                        class="carousel-slide">
                        <img
                            :src="step.img"
                            class="help-picto">
                        <div
                            class="help-text">
                            <h2>Etape {{ i + 1 }}</h2>
                            <p>{{ step.text }}</p>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/partials/ui/PageTitle';
export default {
    name: 'Help',
    components: {
        PageTitle
    },
    data () {
        return {
            steps: [
                {
                    text: 'Je renseigne les moteurs de mon site dans la section "Les moteurs de mon site".',
                    img: '/static/images/step-1.svg'
                },
                {
                    text: 'Je valide une sélection des moteurs les plus intéressants à auditer, et renseigne leurs caractéristiques détaillées.',
                    img: '/static/images/step-2.svg'
                },
                {
                    text: 'Je commande, je reçois et j\'installe mon kit motorbox.',
                    img: '/static/images/step-3.svg'
                },
                {
                    text: 'Une fois l\'audit terminé, je renvoie le kit à EDF en utilisant le colis fourni.',
                    img: '/static/images/step-4.svg'
                },
                {
                    text: 'Je reçois mon rapport d\'audit indiquant mes consommations, les gains potentiels et les solutions d\'économie conseillées.',
                    img: '/static/images/step-5.svg'
                }
            ]
        };
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.carousel-wrapper {
    max-width: $layout-width;
    margin: auto;
    padding: 20px;
}
.help-carousel {
    background: white;
    border-radius: 4px;
    .el-carousel__indicator .el-carousel__button {
        background: $--color-primary;
    }
    .carousel-slide {
        position: relative;
        padding-left: 340px;
        padding-top: 100px;
        padding-right: 80px;
        height: 100%;
        .help-picto {
            display: block;
            position: absolute;
            top: 50%;
            left: 80px;
            transform: translate(0, -50%);
        }
        h2 {
            font-weight: bold;
            font-size: 30px;
            margin: 0;
            margin-bottom: 20px;
            color: $--color-primary
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Help/index.vue